@if (authService.authenticated) {
  @if (favorite$ | async) {
    <ng-content select=".remove">
    </ng-content>
  } @else {
    <ng-content select=".add">
    </ng-content>
  }
} @else {
  @if (tenantService.isAggregator) {
    <a routerLink="/connexion"
      >
      <ng-container *ngTemplateOutlet="tempOutlet" ></ng-container>
    </a>
  }
  @if (!tenantService.isAggregator) {
    <a href="{{this.tenantService.aggregator.url}}/connexion"
      >
      <ng-container *ngTemplateOutlet="tempOutlet" ></ng-container>
    </a>
  }
}
<ng-template #tempOutlet>
  <ng-content select=".noauth"></ng-content>
</ng-template>
